import { render, staticRenderFns } from "./GlobalDashboardDoughnutChart.vue?vue&type=template&id=02179415&scoped=true&"
import script from "./GlobalDashboardDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./GlobalDashboardDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDashboardDoughnutChart.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GlobalDashboardDoughnutChart.vue?vue&type=style&index=1&id=02179415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02179415",
  null
  
)

export default component.exports